import CryptoJS from "crypto-js";
import { diff } from "deep-object-diff";
import moment from "moment";

export const checkSwipeDirection = (e, startX, startY) => {
    let dir = "";
    let pageX = e.touches[0].pageX;
    let pageY = e.touches[0].pageY;

    let distX = pageX - startX;
    let distY = pageY - startY;

    if (Math.abs(distX) > Math.abs(distY)) {
        dir = distX < 0 ? "left" : "right";
    } else {
        dir = distY < 0 ? "up" : "down";
    }

    return dir;
};

export const isEmpty = (obj) => {
    for (let key in obj) {
        // если тело цикла начнет выполняться - значит в объекте есть свойства
        return false;
    }
    return true;
};

export const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const intToString = (value) => {
    const suffixes = ["", "k", "m", "b", "t"];
    const suffixNum = Math.floor(("" + value).length / 3);
    let shortValue = parseFloat((suffixNum != 0 ? value / Math.pow(1000, suffixNum) : value).toPrecision(2));
    if (shortValue % 1 != 0) {
        shortValue = shortValue.toFixed(1);
    }
    return shortValue + suffixes[suffixNum];
};

export const getElemHeight = (id) => {
    const elem = document.getElementById(id);
    if (elem) return elem.clientHeight;
};

export const scrollOffsetTop = (id) => {
    const elem = document.getElementById(id);
    if (elem) return elem.offsetTop;
};

const buildNestedObject = (keysAndValues, index = 0) => {
    if (index === keysAndValues.length - 1) {
        const { key } = keysAndValues[index];
        return key ? `${key}` : ""; // Последний уровень — пустая строка
    }

    const { key, value } = keysAndValues[index];
    return { [key]: buildNestedObject(keysAndValues, index + 1) };
};

export const getWhatId = () => {
    const location_search = window && window.location && window.location.search ? window.location.search : {};
    const urlParams = new URLSearchParams(location_search);
    const what_id = urlParams.get("what_id");

    return what_id ? what_id : null;
};

export const pluralForm = (n, arrType = []) => {
    return arrType[n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2];
};

export function getSqlServerGuidHash(offerCode, vendorId) {
    const code = offerCode ?? "!@#D";
    const vendor = vendorId ?? "!@#T";
    const combined = code + vendor;

    // Получаем MD5-хеш в виде слова (WordArray)
    const hash = CryptoJS.MD5(CryptoJS.enc.Utf8.parse(combined));

    // Преобразуем в массив байтов
    const hex = hash.toString(CryptoJS.enc.Hex);
    const bytes = [];

    for (let i = 0; i < hex.length; i += 2) {
        bytes.push(parseInt(hex.substr(i, 2), 16));
    }

    // SQL Server GUID порядок байт:
    // Byte order: 4-2-2-2-6 (но первые три группы в little-endian)
    const toLittleEndian = (arr) => arr.reverse();

    const part1 = toLittleEndian(bytes.slice(0, 4));
    const part2 = toLittleEndian(bytes.slice(4, 6));
    const part3 = toLittleEndian(bytes.slice(6, 8));
    const part4 = bytes.slice(8, 10);
    const part5 = bytes.slice(10, 16);

    const guidBytes = [...part1, ...part2, ...part3, ...part4, ...part5];

    // Форматируем как GUID
    const byteToHex = (b) => b.toString(16).padStart(2, "0");
    const guidHex = guidBytes.map(byteToHex);

    const guid = `${guidHex.slice(0, 4).join("")}-${guidHex.slice(4, 6).join("")}-${guidHex.slice(6, 8).join("")}-${guidHex.slice(8, 10).join("")}-${guidHex.slice(10, 16).join("")}`;

    return guid.toLowerCase();
}

export const updateParamWithoutRerender = (key, value) => {
    const url = new URL(window.location.href);

    if (value.trim() === "") {
        url.searchParams.delete(key);
    } else {
        url.searchParams.set(key, value);
    }
    window.history.pushState({}, "", url.toString());
};

export const clearParamWithoutRerender = (arr) => {
    const url = new URL(window.location.href);
    arr.forEach((key) => url.searchParams.delete(key));
    setTimeout(() => window.history.replaceState({}, "", url.toString()));
};

export const clearAllParamWithoutRerender = () => setTimeout(() => window.history.replaceState({}, "", window.location.pathname || "/"));

export const isMobileDevice = () => {
    const userAgent = window.navigator.userAgent;
    const mobileKeywords = ["Android", "webOS", "iPhone", "iPad", "iPod", "BlackBerry", "Windows Phone", "Opera Mini", "IEMobile", "Mobile"];

    return mobileKeywords.some((keyword) => userAgent.includes(keyword));
};

export function formatPhoneNumber(phone, isModal = false) {
    // Удаляем все нецифровые символы

    if (phone) {
        const cleanPhone = phone.replace(/\D+/g, "");

        if (!cleanPhone.startsWith("7") && !cleanPhone.startsWith("8")) {
            return phone; // Возвращаем оригинальный номер если он не подходит
        }

        if (isModal) {
            return cleanPhone.replace(/^(\d)(\d{3})(\d{3})(\d{2})(\d{2})$/, "+$1 $2 $3-$4-$5");
        }

        return cleanPhone.replace(/^(\d)(\d{3})(\d{3})(\d{2})(\d{2})$/, "+$1 ($2) $3-$4-$5");
    }

    return "";
}

export const isStartScreenWidth = (width) => (window.innerWidth <= width ? true : false);

export const randomNumber = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1) + min);
};

export const findKeyByPath = (nodes, path, parentKey = null) => {
    for (const node of nodes) {
        if (Array.isArray(node)) {
            const result = findKeyByPath(node, path, node.key);
            if (result) return result;
        }

        if (node?.path == path) {
            return { key: node.key, parentKey };
        }
        if (node.children) {
            const result = findKeyByPath(node.children, path, node.key);
            if (result) return result;
        }
    }
    return null;
};

export const translit = (title) => {
    const normalized = String(title)
        .replace(/\&amp;nbsp;/gi, "_")
        .replace(/\&nbsp;/gi, "_");
    const red = normalized
        .trim()
        .toLowerCase()
        .split("")
        .reduce((acc, char) => {
            let l = emptyAlias.includes(char) ? "" : spaceAlias.includes(char) ? "_" : charAliases[char] || char;

            if (l === "_" && (!acc.length || acc[acc.length - 1] === "_")) {
                return acc;
            }
            acc += l;
            return acc;
        }, "");

    return red.slice(-1) === "_" ? red.slice(0, -1) : red;
};

export const differ = (obj1 = {}, obj2 = {}) => {
    if (!obj1 || !obj2) return false;
    const res = diff(obj1, obj2);

    const restoreArrays = (source, target, diffNode) => {
        if (!diffNode || typeof diffNode !== "object") return;

        Object.keys(diffNode).forEach((key) => {
            const sourceVal = source?.[key];
            const targetVal = target?.[key];
            const diffVal = diffNode[key];

            if (sourceVal && Array.isArray(sourceVal)) {
                const newTargetVal = targetVal?.length ? targetVal : null;
                diffNode[key] = newTargetVal;
            } else if (diffVal && typeof diffVal === "object" && sourceVal && typeof sourceVal === "object" && !Array.isArray(sourceVal) && targetVal && typeof targetVal === "object" && !Array.isArray(targetVal)) {
                restoreArrays(sourceVal, targetVal, diffVal);
            }
        });
    };

    restoreArrays(obj1, obj2, res);
    return res;
};

export const changeValByPath = (path, value, state, isMutate = false) => {
    let newObj = state;

    if (!isMutate) {
        const stateToStr = JSON.stringify(state); // иначе мутирует
        newObj = JSON.parse(stateToStr);
    }

    return path.split(".").reduce((acc, row, idx, arr) => {
        if (idx == arr.length - 1) {
            acc[row] = value;
            return newObj;
        }
        if (acc[row] == null || typeof acc[row] == "undefined") acc[row] = {};

        return acc[row];
    }, newObj);
};

export const getValByPath = (path, state) => {
    const val = path.split(".").reduce((acc, key) => acc?.[key], state);
    return val ?? undefined;
};

var charAliases = {
    а: "a",
    б: "b",
    в: "v",
    г: "g",
    д: "d",
    е: "e",
    ё: "e",
    ж: "zh",
    з: "z",
    и: "i",
    й: "y",
    к: "k",
    л: "l",
    м: "m",
    н: "n",
    о: "o",
    п: "p",
    р: "r",
    с: "s",
    т: "t",
    у: "u",
    ф: "f",
    х: "h",
    ц: "c",
    ч: "ch",
    ш: "sh",
    щ: "sch",
    ь: "",
    ы: "y",
    ъ: "",
    э: "e",
    ю: "yu",
    я: "ya",

    А: "A",
    Б: "B",
    В: "V",
    Г: "G",
    Д: "D",
    Е: "E",
    Ё: "E",
    Ж: "Zh",
    З: "Z",
    И: "I",
    Й: "Y",
    К: "K",
    Л: "L",
    М: "M",
    Н: "N",
    О: "O",
    П: "P",
    Р: "R",
    С: "S",
    Т: "T",
    У: "U",
    Ф: "F",
    Х: "H",
    Ц: "C",
    Ч: "Ch",
    Ш: "Sh",
    Щ: "Sch",
    Ь: "",
    Ы: "Y",
    Ъ: "",
    Э: "E",
    Ю: "Yu",
    Я: "Ya",
};
const spaceAlias = ["?", " ", "\u00A0", ":", "-", "–", ".", "|", '"', "'", "!", "@", ",", "*", "(", ")", "#", "№", "~", "+", "/", "\\", "[", "]", "’", "ь", "ъ", "«", "»"];
const emptyAlias = ["ь", "ъ"];

export const getStatusTag = (item) => {
    const tags = {
        active: { title: "Активный", icon: "pi pi-circle-fill", type: "success" },
        archived: { title: "В архиве", icon: "pi pi-inbox", type: "danger" },
        draft: { title: "Черновик", icon: "pi pi-bookmark", type: "secondary" },
        paused: { title: "На паузе", icon: "pi pi-pause", type: "warning" },
    };
    if (item.active) return tags.active;
    if (item.archived) return tags.archived;
    if (item.draft) return tags.draft;

    return tags.paused;
};

export const handleCopyBuffer = (e = false, item, key, cb = () => {}) => {
    if (e) e.stopPropagation();
    const val = JSON.stringify(item[key]).replace(/"/gim, ""); //на всякий сдучай, чтоб в строку перегонял
    navigator.clipboard.writeText(val).then(() => cb(val));
};

export const isDateBetween = (dateStart, dateEnd, now = moment()) => {
    if (!dateStart || !dateEnd) return false;
    return now.isBetween(moment(dateStart), moment(dateEnd), null, "[]");
};

export const modifyData = (arr, key) => Object.fromEntries(arr.map((row) => [row[key], row]));

export function validateRequiredFields(inputsConfig, formData) {
    const errors = [];
    const nameInput = [];

    // console.log(inputsConfig, "inputsConfig");
    // console.log(formData, "formData");

    // Вспомогательная функция для получения значения по пути 'a.b.c'
    function getNestedValue(obj, path) {
        if (path === "vendor.rateIds") {
            path = "ratesArray";
        }
        return path.split(".").reduce((acc, part) => (acc != null ? acc[part] : undefined), obj);
    }

    // Проверка видимости поля с учётом триггеров
    function isVisible(fieldConfig, data, currentPath = "") {
        const triggerKey = fieldConfig.triggerShow;
        if (!triggerKey) return true;

        const triggerValue = fieldConfig.triggerShowValue;

        // Если триггер — это путь (например, "mailOptions.notSend"), используем его напрямую
        let triggerFieldValue = getNestedValue(data, triggerKey);

        // Особый случай: triggerKeys для массивов (например, inputFields с type: "phone")
        if (fieldConfig.triggerKeys && Array.isArray(getNestedValue(data, triggerKey))) {
            const array = getNestedValue(data, triggerKey);
            const matches = array.some((item) => {
                return Object.entries(fieldConfig.triggerKeys).every(([k, v]) => item[k] === v);
            });
            return matches === Boolean(triggerValue);
        }

        // Обычное сравнение
        if (Array.isArray(triggerValue)) {
            return triggerValue.includes(triggerFieldValue);
        }
        return triggerFieldValue === triggerValue;
    }

    // Рекурсивная функция для обхода полей
    function traverseInputs(inputs, parentPath = "") {
        for (const [key, config] of Object.entries(inputs)) {
            const currentPath = parentPath ? `${parentPath}.${key}` : key;

            // console.log(currentPath, "currentPath");
            // console.log(key, "key");

            // Если это контейнер (objectInputs), углубляемся
            if (config.type === "objectInputs" && config.inputs) {
                traverseInputs(config.inputs, currentPath);
                continue;
            }

            // Пропускаем, если не required
            if (!config.required) continue;

            // Проверяем видимость
            if (!isVisible(config, formData, currentPath)) continue;

            // Получаем значение из formData
            const value = getNestedValue(formData, currentPath);

            let isEmpty = false;

            if (currentPath === "dateEnd") {
                const dateToCheck = moment.utc(value);
                const startOfTodayUtc = moment.utc().startOf("day");
                const isTodayOrLater = dateToCheck.isSameOrAfter(startOfTodayUtc);
                if (!isTodayOrLater) {
                    isEmpty = true;
                }
            }

            if (value == null || value === "" || value === undefined) {
                isEmpty = true;
            } else if (Array.isArray(value) && value.length === 0) {
                isEmpty = true;
            } else if (typeof value === "object" && !(value instanceof Date) && !(value instanceof File) && Object.keys(value).length === 0) {
                isEmpty = true;
            } else if (Object.values(value).some((s) => s === null)) {
                isEmpty = true;
            }

            if (isEmpty) {
                const label = config.label || currentPath;

                if (label === "vendorInfo.INN") {
                    nameInput.push("ИНН");
                } else {
                    nameInput.push(label);
                }

                errors.push(key);
            }
        }
    }

    // Обход всех блоков
    inputsConfig.forEach((block) => {
        if (block.inputs) {
            traverseInputs(block.inputs);
        }
    });

    return { errors: errors, name: nameInput };
}

export const captureScreenshot = async (elementScreen, mainStore, nameImg) => {
    const preloadAndReplaceImages = async (item) => {
        let el = item;
        const images = el?.querySelectorAll("img");
        if (!images) return;

        for (let img of images) {
            const originalSrc = img.src;
            if (originalSrc.startsWith("data:") || originalSrc.startsWith("blob:")) {
                continue;
            }
            const response = await fetch(originalSrc, {
                method: "GET",
                mode: "cors",
                cache: "no-cache",
                credentials: "same-origin",
                headers: {
                    Accept: "image/*",
                },
            });

            if (!response.ok) throw new Error(`HTTP ${response.status}`);

            const blob = await response.blob();
            const url = URL.createObjectURL(blob);

            img.src = url;
            img.crossOrigin = "anonymous";
            setTimeout(() => {
                img.src = originalSrc;
            });
        }
    };

    if (elementScreen) {
        try {
            await preloadAndReplaceImages(elementScreen);
            const imgData = await toBlob(elementScreen);
            const file = new File([imgData], `${nameImg}`, { type: "image/png" });
            const formData = new FormData();
            formData.append("file", file);
            const response = await mainStore.uploadImage("offers_screenshot/erid", formData);
            if (response && response.data) {
                return response.data;
            }
        } catch (error) {
            console.error("Ошибка при создании скриншота:", error);
            mainStore.setMainStore("toast", { severity: "error", summary: `❌ Ошибка при создании скриншота` });
        }
    }
};
